import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { LayoutComponent } from './layouts/layout/layout.component';
import { AuthService } from './_services/auth.service';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HeaderComponent } from './layouts/header/header.component';
import { HttpAPIInterceptor } from './_core/interceptors/http-api.interceptor';
import { FooterComponent } from './layouts/footer/footer.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastrModule } from 'ngx-toastr';
import { UnauthorizeComponent } from './layouts/unauthorize/unauthorize.component';
import { AuthModule } from './modules/auth/auth.module';
import { ConfigurationLayoutComponent } from './layouts/configuration-layout/configuration-layout.component';
import { LoginModule } from './modules/auth/login/login.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    UnauthorizeComponent,
    ConfigurationLayoutComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgSelectModule,
    AppRoutingModule,
    ToastrModule.forRoot({ positionClass: 'toast-top-right', closeButton: true, timeOut: 6000 }), //Display toaster at top right position with close icon
    AuthModule,
    LoginModule,
    DashboardModule
  ],
  providers: [AuthService, GoogleAnalyticsService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: HttpAPIInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
